/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiReportActivitiesQueryResponse,
  GetApiReportActivitiesQueryParams,
} from '../models/GetApiReportActivities.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  InfiniteData,
  QueryKey,
  QueryClient,
  InfiniteQueryObserverOptions,
  UseInfiniteQueryResult,
} from '@tanstack/react-query';
import { getApiReportActivitiesQueryResponseSchema } from '../zod/getApiReportActivitiesSchema.ts';
import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

export const getApiReportActivitiesInfiniteQueryKey = (
  params: GetApiReportActivitiesQueryParams,
) => [{ url: '/api/report/activities' }, ...(params ? [params] : [])] as const;

export type GetApiReportActivitiesInfiniteQueryKey = ReturnType<
  typeof getApiReportActivitiesInfiniteQueryKey
>;

/**
 * {@link /api/report/activities}
 */
export async function getApiReportActivitiesInfinite(
  params: GetApiReportActivitiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiReportActivitiesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/report/activities`,
    params,
    ...requestConfig,
  });
  return getApiReportActivitiesQueryResponseSchema.parse(res.data);
}

export function getApiReportActivitiesInfiniteQueryOptions(
  params: GetApiReportActivitiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiReportActivitiesInfiniteQueryKey(params);
  return infiniteQueryOptions<
    GetApiReportActivitiesQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiReportActivitiesQueryResponse,
    typeof queryKey,
    number
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal, pageParam }) => {
      config.signal = signal;

      if (params) {
        params['PageNumber'] =
          pageParam as unknown as GetApiReportActivitiesQueryParams['PageNumber'];
      }
      return getApiReportActivitiesInfinite(params, config);
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage['nextPageNumber'],
    getPreviousPageParam: (firstPage) => firstPage['nextPageNumber'],
  });
}

/**
 * {@link /api/report/activities}
 */
export function useGetApiReportActivitiesInfinite<
  TData = InfiniteData<GetApiReportActivitiesQueryResponse>,
  TQueryData = GetApiReportActivitiesQueryResponse,
  TQueryKey extends QueryKey = GetApiReportActivitiesInfiniteQueryKey,
>(
  params: GetApiReportActivitiesQueryParams,
  options: {
    query?: Partial<
      InfiniteQueryObserverOptions<
        GetApiReportActivitiesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiReportActivitiesInfiniteQueryKey(params);

  const query = useInfiniteQuery(
    {
      ...getApiReportActivitiesInfiniteQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as InfiniteQueryObserverOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
